import LTR from "@brand-icons/global/bills-and-discounts/bills-and-discounts-ltr.svg";

import { iconFactory } from "../iconFactory";

export const BillsAndDiscountsIcon = iconFactory("BillsAndDiscountsIcon", LTR);
